import { createSlice,createAsyncThunk } from '@reduxjs/toolkit';
import initialState from './fieldsJSON';
import {generateUUID} from "../quote/quoteAPI"
import { quoteIfCan } from '../quote/quoteSlice';
import fieldsMiddleware from './fieldsMiddleware';
import _ from "lodash"


export const fieldsSlice = createSlice({
    name: 'fields',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
      newGUIDforQuote: (state,action) => {
        state.user.guid.value = generateUUID();
      },
      setField: (state,action) => {
        _.set(state,`${action.payload.field}.value`.split("."),action.payload.value)
      },
      setOptions: (state,action) => {
        _.set(state,`${action.payload.field}.options`.split("."),action.payload.options)
      },
      setEnabled: (state,action) => {
        _.set(state,`${action.payload.field}.enabled`.split("."),action.payload.enabled)
      },
      addObject: (state, action) => {
        var JSONObject = _.get(state,action.payload.objectPath,false);
        JSONObject.values[(typeof action.payload.objectIndex !== "undefined")?action.payload.objectIndex:JSONObject.values.length] = JSONObject.model
      },
      removeObjectAt: (state, action) => {
        var JSONObject = _.get(state,action.payload.objectPath,false);
        //console.log(state,action.payload.index )
        JSONObject.splice(action.payload.index,1);
      },
      removeLastObject: (state, action) => {
        var JSONObject = _.get(state,action.payload.objectPath,false);
        JSONObject.values.pop();
      }
    },
    extraReducers: (builder) => {
      builder.addCase(setFieldData.fulfilled,(state,action) => {
        //_.set(state,`${action.payload.path}.value`.split("."),action.payload.value)
        //thunkAPI.dispatch(setField({field:action.payload.path,value:action.payload.value}))
      })
    }
});

export const { newGUIDforQuote,setField,setOptions,setEnabled,addObject,removeObjectAt,removeLastObject } = fieldsSlice.actions;

export const setFieldData = createAsyncThunk(
  'fields/setFieldData',
  async (data,thunkAPI) => {
    var middleware = _.get(thunkAPI.getState().fields,`${data.path}.middleware`.split("."),false);
    if(middleware !== false)
      data.value = await fieldsMiddleware[middleware]({path:data.path,value:data.value},thunkAPI.getState(),thunkAPI.dispatch);
    
    thunkAPI.dispatch(setField({field:data.path,value:data.value}))
    thunkAPI.dispatch(quoteIfCan())
    return {path:data.path,value:data.value};
  }
);

export const fillFromURL = () => async (dispatch, getState) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const entries = urlParams.entries();

  for (const [key, value] of entries) {
    
    if(key.slice(0,3) === "utm"){
      document.querySelector("body").setAttribute(key,value)
      continue;
    }

    var JSONpath = _.chain(key).split("_").map((o) => { if(o.length === 5) return `${o}.values`;else if(!isNaN(parseFloat(o)) && isFinite(o)) return parseInt(o)-1; else return o;}).join(".").value()
    
    var isAvailable = _.get(getState().fields,JSONpath,false);
    
    if(isAvailable === false){

      var objects = JSONpath.split(".").filter(o => o.length === 5 || o.length < 4);

      var objectPaths = 
        _.chain(objects)
        .map((o)=>{
            if(o.length === 5)
              return JSONpath.slice(0,JSONpath.indexOf(o)+o.length);
            return o
        })
        .chunk(2)
        .value();

        objectPaths.forEach(async (o) => {
          dispatch(addObject({objectPath:o[0],objectIndex:o[1]}))
        });

    }

    await dispatch(setFieldData({path:JSONpath,value:value}));

  }

};

export default fieldsSlice.reducer;